import React, {Fragment, useEffect, useRef} from "react";
import {useState} from "react";
// import {makeStyles} from "@material-ui/core/styles";
import {
  Backdrop, Box,
  Button,
  CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid,
  Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
} from "@mui/material";
import axios from "axios";
import BarcodeReader from 'react-barcode-reader'
import {useHistory} from "react-router-dom";
import cookie from "react-cookies";
import {RECEIVER_COOKIE_KEY} from "../constant";
import {changeImageURL} from "../stringutils";
import {useSnackbar} from "notistack";

// const useStyles = makeStyles((theme) => ({
//   // root: {
//   //   width : '100%',
//   //   height: '100%',
//   //   display: 'flex',
//   // },
//   // body: {
//   //   paddingBottom: 70,
//   //   height: "auto",
//   //   width: "100%"
//   // },
//   // footer: {
//   //   // overflow: 'hidden',
//   //   position: "fixed",
//   //   backgroundColor : 'white',
//   //   bottom: 0,
//   //   left: 0,
//   //   zIndex: 100,
//   //   height: 70,
//   //   width: "100%",
//   //   // paddingLeft: theme.spacing(1),
//   //   // paddingRight: theme.spacing(1),
//   //   // backgroundColor: theme.palette.primary.main,
//   //   display: 'flex',
//   //   // flex: 1,
//   //   flexDirection: 'row',
//   //   // alignItems: 'stretch',
//   //   justifyContent: 'center',
//   //   // justifyItems: 'center',
//   //   // alignContent: 'space-evenly',
//   // },
//   // back_button: {
//   //   color : 'white',
//   // },
//   // layout_progress: {
//   //   marginTop: theme.spacing(18),
//   //   display: 'flex',
//   //   flexDirection: 'column',
//   //   alignItems: 'center'
//   // },
//   // layout_message: {
//   //   marginTop: theme.spacing(18),
//   //   display: 'flex',
//   //   flexDirection: 'column',
//   //   alignItems: 'center'
//   // },
//   // title: {
//   //   alignSelf: 'center',
//   //   color : 'white',
//   //   // color : theme.palette.text
//   // },
//   // main: {
//   //   // width : '100%',
//   //   paddingLeft: theme.spacing(3),
//   //   paddingRight: theme.spacing(3),
//   //   // paddingTop: theme.spacing(1),
//   //   // paddingBottom: theme.spacing(1),
//   // },
//   // search_bar: {
//   //   overflow: 'hidden',
//   //   position: "fixed",
//   //   top: 0,
//   //   zIndex: 100,
//   //   height: 60,
//   //   width: "100%",
//   //   paddingLeft: theme.spacing(1),
//   //   paddingRight: theme.spacing(1),
//   //   display: 'flex',
//   //   flexDirection: 'row',
//   // },
//   // rowItemClickable :{
//   //   cursor : 'pointer',
//   //   display : 'flex',
//   //   alignItems : 'center',
//   // },
//   backdrop: {
//     zIndex: theme.zIndex.drawer + 1,
//     color: '#fff',
//   },
// }));

const rowItemClickable = {
  cursor : 'pointer',
  display : 'flex',
  alignItems : 'center',
}

export default function RegisterView(props){
  // const style = useStyles()
  const history = useHistory()

  const [deleteDialog, setDeleteDialog] = useState({
    open : false,
    id_fs : null,
    barcode : null,
    name : null,
  })
  const [openDialog, setOpenDialog] = useState(false)
  const [dialogMessage, setDialogMessage] = useState("")
  const [errorMessage, setErrorMessage] = useState("")

  // const [openRegisterDialog, setOpenRegisterDialog] = useState(false)

  // const [openAutoComplete, setOpenAutoComplete] = React.useState(false)

  // const [loadingProducts, setLoadingProducts] = useState(true)
  // const [products, setProducts] = useState([])

  const [requesting, setRequesting] = useState(false)
  const [message, setMessage] = useState("")

  const [barcode, setBarcode] = useState('')
  // const [productName, setProductName] = useState('')
  const [productCode, setProductCode] = useState('')
  const [productOptionCode, setProductOptionCode] = useState('')
  const [locationCode, setLocationCode] = useState('')
  const [selectedProduct, setSelectedProduct] = useState(null)

  // const [openSnackbar, setOpenSnackbar] = useState(false)
  // const [snackbarMessage, setSnackbarMessage] = useState(null)
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [productList, setProductList] = useState([])

  // const [autoCompleteFocus, setAutoCompleteFocus] = useState(null)

  // const searchInput = useRef(null);
  const [imageShow, setImageShow] = useState({
    open : false,
    url : '',
    title : ''
  })

  const registerInput = useRef(null);

  useEffect(()=>{
    if(props.products && props.products.length > 0){
      setSelectedProduct(props.products[0])
      changeSelected(props.products[0])
      getBarcodeFromIdFs(props.products[0].id_fs)

      setTimeout(()=>{
        // button disabled => enabled 로 변경 될때에 focus 안되는 문제 해결을 위해
        // 100ms 이후에 focus 시키도록 함
        if(Boolean(barcode)){
          if(registerInput.current != null){
            registerInput.current.focus()
          }
          return true;
        }
      }, 100)

    }else{
      setSelectedProduct(null)
      changeSelected(null)
      setProductList([])
    }
  }, [props.products])

  const getBarcodeFromIdFs = (id_fs) => {
    setRequesting(true)
    setMessage("")
    setProductList([])
    axios.get(`${process.env.REACT_APP_API_HOST}/barcode?id_fs=${id_fs}&token=${cookie.load(RECEIVER_COOKIE_KEY)}`)
      .then((resp)=>{

        if (resp.status === 200 &&
            resp.data != null &&
            resp.data['code'] === 200){

          if(resp.data['results'].length > 0){
            let results = resp.data['results']
            console.log(results)
            setProductList(results)
          }
        }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0){
          history.replace('/signin')
        }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 499){
          cookie.remove(RECEIVER_COOKIE_KEY)
          history.replace('/not-permitted')
        }else{
          setDialogMessage("상품의 바코드 조회에 실패 하였습니다.")
          setErrorMessage("오류코드 : " + resp.status)
          setOpenDialog(true)
        }

        setRequesting(false)
      })
      .catch((e)=>{
        console.log('error : ' + e);
        setDialogMessage("상품의 바코드 조회에 실패 하였습니다.")
        if(e.response != null && e.response.status > 0){
          setErrorMessage("오류코드 : " + e.response.status)
        }else{
          setErrorMessage("네트워크 환경을 확인 해 주세요")
        }

        setOpenDialog(true)
        setRequesting(false)

      });
  }

  const handleScan = (result) => {
    console.log('handleScan ' + result)

    setProductList([])
    setBarcode(result)

    setRequesting(true)
    setMessage("")

    axios.get(`${process.env.REACT_APP_API_HOST}/product?barcode=${result}&token=${cookie.load(RECEIVER_COOKIE_KEY)}`)
      .then((resp)=>{

        if (resp.status === 200 &&
            resp.data != null &&
            resp.data['code'] === 200){

          if(resp.data['results'].length > 0){
            let results = resp.data['results']
            console.log(results)
            setSelectedProduct(results[0])
            changeSelected(results[0])
            setProductList(results)
          }else{
            setSelectedProduct(null)
            changeSelected(null)
          }
        }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0){
          history.replace('/signin')
        }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 499){
          cookie.remove(RECEIVER_COOKIE_KEY)
          history.replace('/not-permitted')
        }else{
          setDialogMessage("바코드인식에 실패 하였습니다.")
          setErrorMessage("오류코드 : " + resp.status)
          setOpenDialog(true)
        }

        setRequesting(false)
      })
      .catch((e)=>{
        console.log('error : ' + e);
        setDialogMessage("바코드인식에 실패 하였습니다.")
        if(e.response != null && e.response.status > 0){
          setErrorMessage("오류코드 : " + e.response.status)
        }else{
          setErrorMessage("네트워크 환경을 확인 해 주세요")
        }

        setOpenDialog(true)
        setRequesting(false)

      });
  }

  const handleError = (error) => {
      console.log('handleError ' + error)
  }


  useEffect(() => {
    // console.log(props)
    // console.log(match.params.id)

    if (props.barcode){
      // setTitle(props.location.state.barcode)
      console.log("has state " + props.barcode)
      setBarcode(props.barcode)
    }

    return () => {
      console.log('useEffect cleanup')
    }
  }, [props.barcode])


  const changeSelected = (selectedProduct) => {
    if(selectedProduct != null){
      console.log("selectedProduct " + selectedProduct.id + " " + selectedProduct.gsheet_rack_code)
      setProductCode(selectedProduct.id)
      setLocationCode(selectedProduct.gsheet_rack_code)
      setProductOptionCode(selectedProduct.opt_code)
    }else{
      setProductCode("")
      setLocationCode("")
      setProductOptionCode("")
    }
  }

  // useEffect(() => {
  //
  //   changeSelected(selectedProduct)
  //
  //   return () => {
  //     console.log('useEffect selected Product')
  //   }
  // }, [selectedProduct])

  const registerAvailable = () => {
    console.log(registerInput)
    console.log(Boolean(barcode))
    console.log(selectedProduct)
    if(Boolean(barcode) && selectedProduct != null){

      if(registerInput.current != null){
        registerInput.current.focus()
      }
      return true;
    }

    return false;
    // registerInput.current.focusVisible()

    // return Boolean(barcode) && selectedProduct != null
  }


  const deleteBarcode = (id_fs, barcode) => {

    setRequesting(true)
    setMessage("")
    // setOpenRegisterDialog(false)

    axios.delete(`${process.env.REACT_APP_API_HOST}/barcode`, {
      data : {
        params : {
          token : cookie.load(RECEIVER_COOKIE_KEY)
        },
        barcode : barcode,
        idfs : id_fs
      }

    }).then((resp)=>{

      if(resp.status === 200 && resp.data != null && resp.data['code'] === 200){
        // setBarcode("")
        // setSelectedProduct(null)
        // changeSelected(null)

        // setOpenSnackbar(true)
        // setSnackbarMessage("바코드를 삭제 했습니다.")
        enqueueSnackbar("바코드를 삭제 했습니다.", {variant : 'success'})

        let filtered = productList.filter((row) => row.id_fs !== id_fs)
        setProductList(filtered)
        if(filtered.length > 0){
          setSelectedProduct(filtered[0])
          changeSelected(filtered[0])
        }else{
          setSelectedProduct(null)
          changeSelected(null)
        }

      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0){
        history.replace('/signin')
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 499){
        cookie.remove(RECEIVER_COOKIE_KEY)
        history.replace('/not-permitted')
      }else{
        setDialogMessage("바코드 삭제에 실패 하였습니다.")
        if(resp.data != null){
          setErrorMessage("오류코드 : " + resp.data['code'])
        }else{
          setErrorMessage("오류코드 : " + resp.status)
        }
        setOpenDialog(true)
      }

      setRequesting(false)

    }).catch((e) =>{
      setDialogMessage("바코드 삭제에 실패 하였습니다.")
      if(e.response != null && e.response.status > 0){
        setErrorMessage("오류코드 : " + e.response.status)
      }else{
        setErrorMessage("네트워크 환경을 확인 해 주세요")
      }

      setOpenDialog(true)
      setRequesting(false)
    })
  }

  const registerBarcode = () => {

    setRequesting(true)
    setMessage("")
    // setOpenRegisterDialog(false)

    axios.post(`${process.env.REACT_APP_API_HOST}/barcode`, {
      params : {
        token : cookie.load(RECEIVER_COOKIE_KEY)
      },
      barcode : barcode,
      idfs : selectedProduct.id_fs
    }).then((resp)=>{

      if(resp.status === 200 && resp.data != null && resp.data['code'] === 200){
        setBarcode("")
        setSelectedProduct(null)
        setProductList([])
        changeSelected(null)

        // setOpenSnackbar(true)
        // setSnackbarMessage("상품등록이 완료되었습니다.")
        enqueueSnackbar("상품등록이 완료되었습니다.", {variant : 'success'})

      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0){
        history.replace('/signin')
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 499){
        cookie.remove(RECEIVER_COOKIE_KEY)
        history.replace('/not-permitted')
      }else{
        setDialogMessage("상품등록에 실패 하였습니다.")
        if(resp.data != null){
          setErrorMessage("오류코드 : " + resp.data['code'])
        }else{
          setErrorMessage("오류코드 : " + resp.status)
        }
        setOpenDialog(true)
      }

      setRequesting(false)

    }).catch((e) =>{
      setDialogMessage("상품등록에 실패 하였습니다.")
      if(e.response != null && e.response.status > 0){
        setErrorMessage("오류코드 : " + e.response.status)
      }else{
        setErrorMessage("네트워크 환경을 확인 해 주세요")
      }

      setOpenDialog(true)
      setRequesting(false)
    })
  }

  const handleKeyPress = (e) => {
    // if(e.charCode === 13) { //  deprecated
    //   this.handleClick();
    // }
    console.log("handleKeyPress")

    if (e.key === "Enter") {
      // this.handleClick();
    }
  };

  const renderProductList = () => {
    return (
      <React.Fragment>
        <Divider style={{marginTop : 20}}/>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>상품명</TableCell>
                <TableCell align="right">바코드</TableCell>
                <TableCell align="right">상품코드</TableCell>
                <TableCell align="right">옵션코드</TableCell>
                <TableCell align="right">위치코드</TableCell>
                <TableCell align="right"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {productList
                .map((row, index) => (
                <TableRow
                  key={index}
                  >
                  <TableCell component="th" scope="row">
                    <div style={{display : 'flex', alignItems: 'center'}}>
                      {
                        row.img_url ?
                          <img
                            onClick={()=>{
                              setImageShow({
                                open: true,
                                url : row.img_url,
                                title : row.name
                              })
                            }}
                            src={changeImageURL(row.img_url)} alt={row.name} style={{...rowItemClickable, width : 48, height : 48}}/>
                          :
                          <div style={{ width : 48, height : 48}}/>
                      }
                      <div style={{marginLeft : 6}}>{row.name}</div>
                    </div>
                  </TableCell>
                  <TableCell align={"right"} component="th" scope="row">
                    {row.barcode}
                  </TableCell>
                  <TableCell align={"right"} component="th" scope="row">
                    {row.id}
                  </TableCell>
                  <TableCell align={"right"} component="th" scope="row">
                    {row.opt_code}
                  </TableCell>
                  <TableCell align={"right"} component="th" scope="row">
                    {row.gsheet_rack_code}</TableCell>
                  <TableCell align="right">
                    {
                       <Button
                        onClick={()=>{
                          setDeleteDialog({
                            open: true,
                            id_fs: row.id_fs,
                            barcode: row.barcode,
                            name: row.name
                          })
                        }}
                        variant={"contained"} color={"primary"}>
                        삭제
                      </Button>
                    }
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </React.Fragment>
    )
  }

  return (
    <Box sx={{
      width : '100%',
      height: '100%',
      display: 'flex',
    }}>
      <Box sx={{
        paddingBottom: 70,
        height: "auto",
        width: "100%"
      }}>
      {
        requesting ?
          <Box sx={{
            marginTop: (theme) => theme.spacing(18),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}>
            <CircularProgress size={34} thickness={4}/>
          </Box>
          :
          <div>
            {
              Boolean(message)?
                <Box sx={{
                  marginTop: (theme) => theme.spacing(18),
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'}}>
                  <p>{message}</p>
                </Box>
                :
                <Box sx={{
                  paddingLeft: (theme) => theme.spacing(3),
                  paddingRight: (theme) => theme.spacing(3),
                }}>
                  <BarcodeReader
                    onError={handleError}
                    onScan={handleScan}
                  />
                  <Grid container direction={'row'}>
                    <Grid item xs={3}>
                      <p>상품명</p>
                    </Grid>
                    <Grid item xs={9}>
                      {/*<ProductSearchBar selected={selectedProduct} onSelected={(value)=>{*/}
                      {/*  setSelectedProduct(value)*/}
                      {/*  changeSelected(value)*/}
                      {/*}}/>*/}
                      {
                        selectedProduct?
                          <div style={{display : 'flex', alignItems: 'center'}}>
                            {
                              selectedProduct.img_url ?
                                <img
                                  onClick={()=>{
                                    setImageShow({
                                      open: true,
                                      url : selectedProduct.img_url,
                                      title : selectedProduct.name
                                    })
                                  }}
                                  style={rowItemClickable} src={changeImageURL(selectedProduct.img_url)} alt={selectedProduct.name} style={{width : 40, height : 40}}/>
                                :
                                <div style={{ width : 40, height : 40, backgroundColor : "#eeeeee"}}/>
                            }
                            <p style={{marginLeft : 6}}>{selectedProduct.name}</p>
                          </div>
                          :
                          <p style={{color : 'gray'}}>상품을 검색해 주세요</p>
                      }
                    </Grid>
                    <Grid item xs={3}>
                      <p>바코드</p>
                    </Grid>
                    <Grid item xs={9}>
                      {
                        barcode?
                          <p>{barcode}</p>
                          :
                          <p style={{color : 'gray'}}>상품의 바코드를 스캔해주세요</p>
                      }
                    </Grid>
                    <Grid item xs={3}>
                      <p>상품코드</p>
                    </Grid>
                    <Grid item xs={9}>
                      <p>{productCode}</p>
                    </Grid>
                    <Grid item xs={3}>
                      <p>옵션코드</p>
                    </Grid>
                    <Grid item xs={9}>
                      <p>{productOptionCode}</p>
                    </Grid>
                    <Grid item xs={3}>
                      <p>위치관리코드</p>
                    </Grid>
                    <Grid item xs={9}>
                      <p>{locationCode}</p>
                    </Grid>
                    {
                      productList.length > 0 ?
                        <Fragment>
                          <Grid item xs={3}>
                            <p>등록된 상품/바코드</p>
                          </Grid>
                          <Grid item xs={9}>
                            <p>{productList.length}개</p>
                          </Grid>
                        </Fragment>

                      :
                        <div/>

                    }

                    <Grid item xs={12}>
                      {
                        productList.length > 0 ?
                          renderProductList()
                          :
                          <div/>
                      }
                    </Grid>
                                        <Grid item xs={12}>
                    <div style={{display:"flex", flexGrow : 1}}/>
                  </Grid>
                  </Grid>

                </Box>

            }
          </div>
        }
        {
          requesting?
            null
            :
            <Box sx={{
              // overflow: 'hidden',
              position: "fixed",
              backgroundColor : 'white',
              bottom: 0,
              left: 0,
              zIndex: 100,
              height: 70,
              width: "100%",
              // paddingLeft: theme.spacing(1),
              // paddingRight: theme.spacing(1),
              // backgroundColor: theme.palette.primary.main,
              display: 'flex',
              // flex: 1,
              flexDirection: 'row',
              // alignItems: 'stretch',
              justifyContent: 'center',
              // justifyItems: 'center',
              // alignContent: 'space-evenly',
            }}>
              <Button
                autoFocus={true}
                ref={registerInput}
                fullWidth={true}
                onKeyPress={handleKeyPress}
                // onClick={()=>setOpenRegisterDialog(true)}
                onClick={()=>registerBarcode()}
                // style={{width: '100%'}}
                variant="contained"
                color={"secondary"}
                disabled={!registerAvailable()}
              >
                등록
              </Button>
            </Box>
        }

      </Box>
      <Dialog
        open={openDialog}
        onClose={()=>setOpenDialog(false)}
      >
        <DialogTitle id="alert-dialog-title">{"오류발생"}</DialogTitle>

        <DialogContent aria-multiline={true}>
          <div>{dialogMessage}</div>
          <div>{errorMessage}</div>

        </DialogContent>
        <DialogActions>
          <Button onClick={()=>setOpenDialog(false)} color="primary">
            닫기
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={deleteDialog.open}
        onClose={()=>setDeleteDialog({...deleteDialog, open: false})}
      >
        <DialogTitle id="alert-dialog-title">{deleteDialog.name}</DialogTitle>

        <DialogContent aria-multiline={true}>
          <div>바코드를 삭제 하시겠습니까?</div>

        </DialogContent>
        <DialogActions>
          <Button onClick={()=>setDeleteDialog({...deleteDialog, open: false})} color="primary">
            취소
          </Button>
          <Button
            onClick={()=>{
              setDeleteDialog({...deleteDialog, open: false})
              deleteBarcode(deleteDialog.id_fs, deleteDialog.barcode)
            }}
            color="secondary">
            삭제
          </Button>
        </DialogActions>
      </Dialog>

      {/*<Dialog*/}
      {/*  key={"register_dialog"}*/}
      {/*  open={openRegisterDialog}*/}
      {/*  onClose={()=>setOpenRegisterDialog(false)}*/}
      {/*>*/}
      {/*  <DialogContent aria-multiline={true}>*/}
      {/*    <div>상품의 바코드를 등록 하시겠어요?</div>*/}
      {/*    <div>{"바코드 " + barcode}</div>*/}
      {/*    <div>{"상품이름" + productName}</div>*/}
      {/*    <div>{"상품코드 " + productCode}</div>*/}

      {/*  </DialogContent>*/}
      {/*  <DialogActions>*/}
      {/*    <Button onClick={()=>setOpenRegisterDialog(false)} color="primary">*/}
      {/*      취소*/}
      {/*    </Button>*/}
      {/*    <Button onClick={()=>registerBarcode()} color="primary">*/}
      {/*      등록*/}
      {/*    </Button>*/}
      {/*  </DialogActions>*/}
      {/*</Dialog>*/}
      <Backdrop style={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        color: '#fff',
      }} open={imageShow.open} onClick={()=> setImageShow({...imageShow, open: false})}>
        <div style={{display : 'flex', flexDirection : 'column', alignItems : 'center'}}>
          <img src={changeImageURL(imageShow.url)} style={{width : 320, height : 320}}/>
          <div style={{marginTop : 10}}>{imageShow.title}</div>
        </div>
      </Backdrop>
    </Box>
  )
}


